import { DocumentHolderModel } from "./document-holder";
import { CaseRelationModel } from "./case-relation";
import { SortableCollection } from "./../collections/sortable-collection";
import { autoinject, transient } from "aurelia-dependency-injection";
import {prop} from "../../decorators/property";
import {backboneModelProperties} from "../../decorators/backbone-properties";
import {CaseDocumentModel} from "./case-document";
import {AppSettings} from "../../app-settings";

@backboneModelProperties({
    relations : [
        {
            type: Backbone.Many,
            key: "CasesToShow",
            relatedModel: Backbone.AssociatedModel
        }
    ],
    defaults: {
        CitingCases: []
    }
})
@transient()
export class CitelineModel extends Backbone.AssociatedModel {

    @prop() public CitingCases: SortableCollection<CaseRelationModel>;
    @prop() public DocumentId: string;
    @prop() public CasesToShow: Backbone.Collection<Backbone.Model>;
    @prop() public CasesToShowCount: number;
    @prop() public CitingCasesCurrent = 1;
    @prop() public DocumentHolder: DocumentHolderModel;

    constructor(options ) {
        super(options);
    }

    public setData(citingCases: SortableCollection<CaseRelationModel>, id: string, docHolder: DocumentHolderModel) {
        this.CitingCases = citingCases; // done here for @Prop() decorator
        this.DocumentId = id;
        this.DocumentHolder = docHolder;
    }

    public async load() {
        const request = this.buildRequest();
        const response = await Promise.resolve($.post(`${AppSettings.DocumentApiUrlPrefix}citelinetarget`, request));
        this.populateResponse(response);
    }

    public async loadSpecific(request) {
        const response = await Promise.resolve($.ajax({
                url: `${AppSettings.DocumentApiUrlPrefix}citeline`,
                data: JSON.stringify(request),
                type: "POST",
                contentType: "application/json",
                dataType: "json"
            }));
        this.populateResponse(response);
    }

    private populateResponse(data: any) {
        const goodCases = [];
        let caseNumber = 1;
        const citingCases: any[] = this.CitingCases.where((r) => r.IsActuallyVisible);
        const unique = _.uniq(citingCases, (c) => c.Id);
        for (const citingCase of unique) {
            const citelineCase: any = _.where(data.CitingCases, {DocKey: citingCase.Id})[0];
            if (!citelineCase) {
                continue;
            }
            citelineCase.Title = citingCase.Title;
            citelineCase.ShortTitle = citingCase.Title.length < 45 ? citingCase.Title : `${citingCase.Title.substr(0, 45)}...`;
            citelineCase.Treatment = citingCase.Treatment.Name;
            citelineCase.TreatmentClass = citingCase.TreatmentClass;
            citelineCase.ItemNumber = caseNumber;
            citelineCase.Court = citingCase.Court.Name;
            citelineCase.Year = citingCase.Year;
            citelineCase.Url = citingCase.Url;
            citelineCase.IconUrl = citingCase.get("IconUrl");
            goodCases.push(citelineCase);
            caseNumber++;
        }

        for (let i = 0; i < goodCases.length; i++) {
            const goodCase = goodCases[i];
            switch (i) {
                case 0:
                    goodCase.InitialClass = "current front";
                    break;
                case 1:
                    goodCase.InitialClass = "next";
                    break;
                default:
                    goodCase.InitialClass = "outside-right";
            }
        }

        this.CasesToShow = new Backbone.Collection();
        this.CasesToShow.add(goodCases);
        this.CasesToShowCount = this.CasesToShow.length;
    }

    private buildRequest(): any {
        const documents = _.take(this.CitingCases.filter((s: any) => (s.CitedReferences) > 0 && (s.IsActuallyVisible === true)).map((s: any) => s.Id), 20);
        const request = {
            Target : this.DocumentId,
            Documents: documents
        };
        return request;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/citeline.ts